import { useTranslation } from "react-i18next";
import HeroSection from "../components/home/hero";
import Features from "../components/home/features";
import WhySpecter from "../components/home/whySpecter";
import ElectronicInvoices from "../components/home/electronicInvoices";
import HowWorks from "../components/home/howWorks";
import Plans from "../components/home/plans";
import DownloadApp from "../components/home/downloadApp";
import Videos from "../components/home/videos";
import Contactus from "../components/home/contactus";
import Footer from "../components/home/footer";

export const SpecterLanding = () => {
  const { i18n } = useTranslation();

  return (
    <main
      key={i18n.language}
      className={`select-none flex flex-col w-full min-h-screen transition-all duration-700  font-montserratArabic`}
    >
      <HeroSection />
      <Features />
      <WhySpecter />
      <ElectronicInvoices />
      <HowWorks />
      <Plans />
      <DownloadApp />
      <Videos />
      <Contactus />
      <Footer />
    </main>
  );
};
